import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionReducer from "./sessionReducer";
import commonReducer from "./commonReducer";
import employeeReducer from "./employeeReducer";
import { ObjectsReducer, ObjectTypesReducer, RolesReducer ,UsersRoleReducer, RolesAccessReducer, UsersReducer } from "pages/AccessManagement/reducers";
import { PostageReducer } from "pages/PostageManagement/reducers";
import { TimesheetCategoryReducer, TimesheetTaskReducer, ProgramSetupReducer, WeeklyTimesheetReducer, TimesheetReportReducer } from "pages/TimeSheetManage/reducers";
import { ProgramReducer, BrandReducer, QueueReducer, ConfigurationReducer } from "pages/AdminManage/reducers";
import { ACDReportReducer } from "pages/ACD/reducers";
import { InvoiceConfigurationReducer } from "pages/InvoiceConfiguration/reducers";
import { InvoicesReducer } from "pages/Invoices/reducers";
import { SetupConfigurationReducer } from "pages/SetupConfiguration/reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["session"],
};

const appReducer = combineReducers({
  session: sessionReducer,
  employeeState: employeeReducer,
  objectsState:ObjectsReducer,
  objectTypesState:ObjectTypesReducer,
  rolesState: RolesReducer,
  commonState: commonReducer,
  usersRoleState :UsersRoleReducer,
  rolesAccessState: RolesAccessReducer,
  postageState: PostageReducer,
  timeSheetCategoryState: TimesheetCategoryReducer,
  timeSheetTaskState: TimesheetTaskReducer,
  programState: ProgramReducer,
  programSetupState: ProgramSetupReducer,
  brandState: BrandReducer,
  queueState: QueueReducer,
  userState: UsersReducer,
  configurationState: ConfigurationReducer,
  weeklyTimesheetState: WeeklyTimesheetReducer,
  timesheetReportsState: TimesheetReportReducer,
  acdReportState: ACDReportReducer,
  invoiceConfigurationState: InvoiceConfigurationReducer,
  invoicesState: InvoicesReducer,
  setupConfigState: SetupConfigurationReducer,
});

const RootReducer = (state, action) => {
  if (action.type === "TOKEN_EXPIRE" || action.type === "SESSION_LOGOUT") {
    state = undefined;
    localStorage.removeItem("token");
    sessionStorage.clear();
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, RootReducer);
